(function () {

	'use strict';

	/*global $:true */

	let cologicAnimations = {

		// initAnimation: function () {
		//
        //     if($('.anbo').length > 0){
		// 		$('#headerMain').addClass('aniSite');
        //             const container = document.querySelector(".linked-elements-container");
        //             new LinkedElementHandler(container);
		//
        //     }
		//
		// },
		//
		// animateMouseIcon: function () {
		// 	if ($('.bc-1').length > 0) {
		//
		// 		setTimeout(function () {
		// 			$('#scrollDown').animate({'opacity': '1', 'top': '80vH'}, 600, function () {
		// 				$('#scrollDown').delay(1000).animate({'opacity': '0', 'top': '100vH'}, 600, function () {
		// 					$('#scrollDown').hide();
		// 				});
		// 			});
		// 		}, 800);
		// 	}
		//
		// }


	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicAnimations);
}());